const isBrowser = typeof window !== "undefined";
const configuredBase = (process.env.REACT_APP_API_BASE_URL || "").trim();

const isLocalHostname = (hostname) =>
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "[::1]";

const resolveApiBase = () => {
  if (!isBrowser) {
    return configuredBase || "/api";
  }

  // In deployed environments, always talk to the same origin that served the app.
  // This prevents stale build-time env vars from sending production traffic to an old host.
  if (!isLocalHostname(window.location.hostname)) {
    return `${window.location.origin}/api`;
  }

  return configuredBase || "/api";
};

const API_BASE_URL = resolveApiBase();

export const apiUrl = (path = "") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
